export var RailPackageServiceActionTypes;
(function (RailPackageServiceActionTypes) {
    RailPackageServiceActionTypes["RECEIVE_RAIL_PACKAGE_GROUPS_RESPONSE"] = "RECEIVE_RAIL_PACKAGE_GROUPS_RESPONSE";
    RailPackageServiceActionTypes["RECEIVE_RAIL_PACKAGE_OFFERS_RESPONSE"] = "RECEIVE_RAIL_PACKAGE_OFFERS_RESPONSE";
    RailPackageServiceActionTypes["RECEIVE_RAIL_PACKAGE_PRODUCTS_RESPONSE"] = "RECEIVE_RAIL_PACKAGE_PRODUCTS_RESPONSE";
    RailPackageServiceActionTypes["RECEIVE_RAIL_PACKAGE_VARIANTS_RESPONSE"] = "RECEIVE_RAIL_PACKAGE_VARIANTS_RESPONSE";
    RailPackageServiceActionTypes["REQUEST_RAIL_PACKAGE_GROUPS"] = "REQUEST_RAIL_PACKAGE_GROUPS";
    RailPackageServiceActionTypes["REQUEST_RAIL_PACKAGE_OFFERS"] = "REQUEST_RAIL_PACKAGE_OFFERS";
    RailPackageServiceActionTypes["REQUEST_RAIL_PACKAGE_PRODUCTS"] = "REQUEST_RAIL_PACKAGE_PRODUCTS";
    RailPackageServiceActionTypes["REQUEST_RAIL_PACKAGE_VARIANTS"] = "REQUEST_RAIL_PACKAGE_VARIANTS";
})(RailPackageServiceActionTypes || (RailPackageServiceActionTypes = {}));
